import { ModelBase } from '../../core/model/model-base';
import { PostalAddress } from '../../common/model/postal-address';
import { LocalDate } from '../../core/model/local-date';
import { Money } from '../../core/model/money';

export class Payment extends ModelBase {
  constructor() {
    super();
    this.payerAddress = new PostalAddress();
    Object.defineProperties(this, {
      _date: { enumerable: false, writable: true },
    });
  }

  private _date: LocalDate;
  amount: Money;
  get date(): LocalDate {
    return this._date;
  }
  set date(value: LocalDate) {
    this._date = LocalDate.fromDate(value);
  }
  payerAddress: PostalAddress;
  payerName: string;
  ocr: string;
  paymentMethod: string;
  bankgiroNumber: string;
  externalId: string;

  toJSON() {
    const data = Object.assign({}, this);
    data.date = this.date;
    return data;
  }
}
